import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IClub, IFirebaseUser, IInvitation, ISport, IUserData } from '../../types';
import { User } from 'firebase/auth';

interface GeneralState {
  user: IFirebaseUser | undefined;
  myClubs: IClub[] | undefined;
  drawerOpen: boolean;
  drawerWidth: number;
  sports: ISport[] | undefined;
  userData: IUserData | undefined;
  isOnPhone: boolean;
  loadingMyClubs: boolean;
}

const initialState: GeneralState = {
  user: undefined,
  myClubs: undefined,
  drawerOpen: false,
  drawerWidth: 0,
  sports: undefined,
  userData: undefined,
  isOnPhone: false,
  loadingMyClubs: true,
};

export const generalSlice = createSlice({
  name: 'general',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<IFirebaseUser | undefined>) => {
      state.user = action.payload;
    },
    setSports: (state, action: PayloadAction<ISport[] | undefined>) => {
      state.sports = action.payload;
    },
    setMyClubs: (state, action: PayloadAction<IClub[] | undefined>) => {
      state.myClubs = action.payload;
    },
    setDrawerOpen: (state, action: PayloadAction<boolean>) => {
      state.drawerOpen = action.payload;
    },
    setUserData: (state, action: PayloadAction<IUserData | undefined>) => {
      state.userData = action.payload;
    },
    setDrawerWidth: (state, action: PayloadAction<number>) => {
      state.drawerWidth = action.payload;
    },
    setIsOnPhone: (state, action: PayloadAction<boolean>) => {
      state.isOnPhone = action.payload;
    },
    setLoadingMyClubs: (state, action: PayloadAction<boolean>) => {
      state.loadingMyClubs = action.payload;
    },
  },
});

export const { setUser, setMyClubs, setDrawerOpen, setDrawerWidth, setSports, setIsOnPhone, setLoadingMyClubs, setUserData } = generalSlice.actions;
export default generalSlice.reducer;